<div class="header">
    <div class="row w-100 m-0">
        <div class="logo-col">
            <div class="logo logo-dark" (click)="removeActiveClass()">
                <a [routerLink]="['/']">
                    <img class="lg-logo" src="assets/images/logo/logo-white.svg" alt="My Trending Stories">
                    <!-- <img class="logo-fold" src="assets/images/logo/logo-white.png" alt="My Trending Stories"> -->
                    <img class="xs-logo" src="assets/images/logo/logo.svg" alt="My Trending Stories">
                </a>
            </div>
            <div class="logo logo-white">
                <a [routerLink]="[ '/']">
                    <img src="assets/images/logo/logo-white.png" alt="My Trending Stories">
                    <img class="logo-fold" src="assets/images/logo/logo-fold-white.png" alt="My Trending Stories">
                </a>
            </div>
        </div>
        <div class="vertical-center menu-col">
            <app-mainmenu class="w-100"></app-mainmenu>
        </div>
        <div class="vertical-center language-col">
            <div class="nav-wrap">
                <ul class="nav-right">
                    <li class="is-search-icon">
                        <a routerLink="/search" aria-label="Search">
                            <i nz-icon nzType="search" theme="outline"></i>
                        </a>
                    </li>
                    <li>
                        <nz-select (ngModelChange)="switchLang($event)" [(ngModel)]="selectedLanguage">
                            <nz-option *ngFor="let option of languageList" [nzLabel]="option.label"
                                [nzValue]="option.code">
                                {{ option.label }}</nz-option>
                        </nz-select>
                    </li>

                    <li *ngIf="isLoggedInUser">
                        <span class="p-h-10 pointer" nz-dropdown [nzDropdownMenu]="profile" [nzTrigger]="'click'"
                            [nzPlacement]="'bottomRight'">
                            <nz-avatar [nzIcon]="'user'" nzSrc="{{ photoURL }}"></nz-avatar>
                        </span>
                        <nz-dropdown-menu #profile="nzDropdownMenu">
                            <ul nz-menu class="p-b-15 p-t-20">
                                <li class="p-h-20 p-b-15 m-b-10 border-bottom">
                                    <div class="d-flex m-r-50">
                                        <nz-avatar nzSize="large" nzSrc="{{ photoURL }}"></nz-avatar>
                                        <div class="m-l-10">
                                            <p class="m-b-0 text-dark font-weight-semibold">
                                                {{ displayName }}
                                            </p>
                                        </div>
                                    </div>
                                </li>

                                <li nz-menu-item (click)='goToConsole()'>
                                    <a class="p-v-5 d-flex align-items-center justify-content-between">
                                        <div>
                                            <i class="opacity-04 font-size-16" nz-icon nzType="lock"
                                                theme="outline"></i>
                                            <span class="m-l-10"> {{'GotoConsole' | translate }}</span>
                                        </div>
                                    </a>
                                </li>

                                <li nz-menu-item>
                                    <a class="p-v-5 d-flex align-items-center justify-content-between"
                                        (click)="signOut()">
                                        <div>
                                            <i class="opacity-04 font-size-16" nz-icon nzType="logout"
                                                theme="outline"></i>
                                            <span class="m-l-10">Logout</span>
                                        </div>
                                    </a>
                                </li>
                            </ul>
                        </nz-dropdown-menu>
                    </li>
                    <li *ngIf="!isLoggedInUser" class="hidden-on-xs">
                        <a class="is-login-link" (click)="routeLogin()">
                            {{'login' | translate }}
                        </a>
                    </li>

                    <li *ngIf="!isLoggedInUser"  class="hidden-on-xs">
                        <button (click)="routeSignup()" nz-button nzType="primary" class="is-sign-up-btn">
                            {{'signUp' | translate }}
                            <img src="assets/images/sign-up.png" alt="sign up icon">
                        </button>
                    </li>

                </ul>
            </div>
        </div>
    </div>


</div>